import React, { FC } from 'react';

import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import TableRowWithActions from '../../../../components/UI/TableRowWithActions';
import { Team } from '../../../../types';
import { MY_ACCOUNT_LINKS } from '../../pages/const';
import useStyles from './styles';

interface OwnerAllTeamsTableRowProps {
  team: Team;
  onEdit: () => void;
  onRemove: () => void;
  onUpdateRole: () => void;
}

const OwnerAllTeamsTableRow: FC<OwnerAllTeamsTableRowProps> = ({
  team,
  onEdit,
  onRemove,
  onUpdateRole,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const actionsList = (
    <>
      <li>
        <Link to={`${MY_ACCOUNT_LINKS.MyTeams}/${team?.id}/invite`}>
          {t('page.account.inviteLearners')}
        </Link>
      </li>
      <li onClick={onUpdateRole}>{t('page.account.becomeManager')}</li>
      <li onClick={onEdit}>{t('page.account.editTeamName')}</li>
      <li onClick={onRemove}>{t('page.account.removeTeam')}</li>
    </>
  );

  return (
    <TableRowWithActions actionsList={actionsList}>
      <>
        <Box className={classes.teamNameCell}>
          <Link to={`${MY_ACCOUNT_LINKS.MyTeams}/${team?.id}`}>
            {t('page.account.teamName', { name: team?.name })}
          </Link>
        </Box>
        <Box className={classes.teamAmountCell}>
          {t('page.account.learnersAmount', { amount: team?.all_members_count })}
        </Box>
      </>
    </TableRowWithActions>
  );
};

export default OwnerAllTeamsTableRow;
